
import * as utils from 'app/utils'
import { isGoodMoment } from 'app/utils/DateCalcs'
import * as _ from 'lodash'
import * as moment from 'moment'

const ourCookieName = 'lastTimeActive'

/**
 * Get the elapsed time between now and the last active time.
 *
 * @returns the duration of elapsed time. 0 if no (or invalid) last time.
 */
function getElapsedIdle(): moment.Duration {
    do {
        const lastActiveTime = utils.getCookie(ourCookieName)
        if (utils.isNullOrUndefined(lastActiveTime)) { break }
        const lat = moment(lastActiveTime)
        if (!isGoodMoment(lat)) { break }
        const elapsed = moment.duration(moment.utc().diff(lat))
        return elapsed
    } while (false)

    return moment.duration(1, 'year') // there, that's surely going to expire!
}

/**
 * Mark the app as active (by writing the current time to our cookie)
 */
const markAppActive = _.debounce(() => {
    const elapsed = getElapsedIdle()
    // tslint:disable-next-line:no-console
    //console.log('Updating lastActiveTime. Was idle for ' + elapsed.as('seconds') + 'secs.')
    document.cookie = ourCookieName + '=' + moment.utc().toISOString()
}, 3 * 1000)

export {
    getElapsedIdle,
    markAppActive
}



// WEBPACK FOOTER //
// ./src/app/containers/RetirementApp/IdletimeManager/index.ts